import { useQuery } from '@tanstack/react-query';
import restClient from '../common/api/restClient';

export const useResultsGroupsChallenges = (name, options = {}) => {
  const prefix = process.env.REACT_APP_PROXY_PREFIX || '';
  return useQuery({
    queryKey: ['resultsGroupsChallenges', name],
    queryFn: async () => {
      const params = name ? { name: name } : {};
      const response = await restClient({
        url: `${prefix}/results/group-challenges`,
        method: 'GET',
        params
      });
      return response;
    },
    staleTime: 0, 
    cacheTime: 0, 
    refetchOnWindowFocus: false,
    ...options
  });
};
